import * as React from 'react';

export default function CheckedIcon({
  className = '',
  height = 24,
  width = 24,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="12" fill="currentColor"></circle>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.631 8.928a.78.78 0 010 1.103l-6.24 6.24a.78.78 0 01-1.103 0l-3.12-3.12A.78.78 0 117.27 12.05l2.568 2.568 5.689-5.689a.78.78 0 011.103 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
